import { Box, styled } from '@mui/joy'

export const VStack = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`

export const HStack = styled(Box)`
    display: flex;
    align-items: center;
    width: 100%;
`

export const MainContent = styled(Box)`
    flex: 1;
`

export const Spacer = styled('span')`
    flex: 1;
`
